module.exports = __webpack_public_path__ + "img/pic_01.86020b52.svg";